module.exports = __webpack_public_path__ + "media/images/yardstick-ruler-black-a7c90f9a5911ee6a99d8f0d8e966ca1c.svg";